import { render, staticRenderFns } from "./PositionModalComponent.vue?vue&type=template&id=483bcb32&"
import script from "./PositionModalComponent.vue?vue&type=script&lang=js&"
export * from "./PositionModalComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports